import styled from 'styled-components';

import { config } from 'config';
// CleverParking "asphalt" header surface (falls back to any per-tenant override).
const bg = config.theme?.header?.background ? config.theme.header.background : '#0c1210';

export const Content = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0px;
  height: 58px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background: ${bg};
  border-bottom: 1px solid #141c18;
  padding: 0 16px;
`;

export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  @media (max-width: 1021px) {
    justify-content: left;
  }
`;
